import { useState } from 'react';

// Disclaimer Modal Component (updated version)
export const DisclaimerModal = ({ onAccept }) => {
    const [isChecked, setIsChecked] = useState(false);
  
    return (
      <div className="popup-overlay disclaimer-overlay">
        <div className="disclaimer-modal">
          <div className="disclaimer-header">
            <h2>⚠️ IMPORTANT DISCLAIMER</h2>
          </div>
          
          <div className="disclaimer-content">
            <div className="disclaimer-scrollable">
              {/* ANNOUNCEMENT SECTION */}
              <div className="announcement-section">
                <h3>🎲 DerpQuest Dice Announcement</h3>
                
                <p><strong>For core DerpQuest mechanics we needed a 20 sided die. So we are experimenting with Paintswap VRF.</strong></p>
                
                <div className="announcement-box">
                  <p>Check it out but <strong className="warning-text">PLEASE interact carefully and at your own risk.</strong></p>
                 
                  <p>⚠️ <strong>Contract is verified but completely unaudited.</strong></p>
                </div>
                
                <div className="game-mechanics">
                  <h4>🎯 Game Mechanics:</h4>
                  <ul>
                    <li><strong>Pick a number 1-20</strong></li>
                    <li><strong>Wager $Derp</strong></li>
                    <li><strong>Transact</strong></li>
                    <li><strong>If you win, receive 19x your wager</strong></li>
                  </ul>
                  
                  <div className="example-box">
                    <h5>💰 Example:</h5>
                    <p>Betting 10 $DERP transfers the $DERP and the VRF Fees (in $S). When the coordinator hits the callback, if the output matches your guess you receive 190 $DERP, which includes your wager.</p>
                    <p><em>This is a casino game, where the house has an advantage (otherwise you'd get 20x on a win).</em></p>
                  </div>
                </div>
                
                <div className="preseason-info">
                  <h4>📊 DerpQuest Preseason 3 Rewards:</h4>
                  <p>We will snapshot your wager volume on:</p>
                  <div className="snapshot-dates">
                    <div className="snapshot-item">
                      <span className="date">January 24th</span>
                      <span className="percentage">- 20%</span>
                    </div>
                    <div className="snapshot-item">
                      <span className="date">January 31st</span>
                      <span className="percentage">- 15%</span>
                    </div>
                    <div className="snapshot-item">
                      <span className="date">February 7th</span>
                      <span className="percentage">- 15%</span>
                    </div>
                    <div className="snapshot-item">
                      <span className="date">February 12th</span>
                      <span className="percentage">- 50%</span>
                    </div>
                  </div>
                  <p className="highlight-text">📈 This will be <strong>CUMULATIVE</strong> at each snapshot.</p>
                  <p className="highlight-text">🏆 Substantial <strong>MANA</strong> will be granted based <strong>LINEARLY</strong> on wager volume.</p>
                  <p className="important-note">✅ <strong>Winning or losing DOES NOT MATTER</strong> - only total wager volume!</p>
                </div>
                
                <div className="bounty-section">
                  <h4>🐛 Bug Bounty Program:</h4>
                  <div className="bounty-box">
                    <p>I will personally sponsor a <strong className="bounty-amount">1M $DERP</strong> bug bounty for any DerpQuest contracts.</p>
                    <p>Please reach out through any private channel (DMs on X or discord) if you have a smart contract bug to report.</p>
                    <p>Share of the 1M $DERP will be determined at the official launch of DerpQuest.</p>
                    <p>- Maxus</p>
                  </div>
                </div>
                
                <div className="announcement-divider">
                  <hr />
                  <span>RISK DISCLAIMER BELOW</span>
                  <hr />
                </div>
              </div>
              {/* END ANNOUNCEMENT SECTION */}
              
              <h3>RISK ACKNOWLEDGEMENT AND TERMS OF USE</h3>
              
              <p><strong>BY USING THIS DAPP, YOU ACKNOWLEDGE AND AGREE TO THE FOLLOWING:</strong></p>
              
              <div className="disclaimer-section">
                <h4>1. GAMBLING RISKS</h4>
                <ul>
                  <li>This is a gambling application involving real cryptocurrency</li>
                  <li>You can and likely will lose money</li>
                  <li>Only gamble with funds you can afford to lose</li>
                  <li>Gambling may be addictive - set limits and gamble responsibly</li>
                </ul>
              </div>
              
              <div className="disclaimer-section">
                <h4>2. SMART CONTRACT RISKS</h4>
                <ul>
                  <li>Smart contracts are experimental technology</li>
                  <li>Bugs or vulnerabilities may result in loss of funds</li>
                  <li>No guarantees of security or functionality</li>
                  <li>You use this dApp at your own risk</li>
                </ul>
              </div>
              
              <div className="disclaimer-section">
                <h4>3. HOUSE LIQUIDITY PROVISION RISKS</h4>
                <ul>
                  <li>Providing liquidity to the house carries significant risk</li>
                  <li>The house can and may lose money</li>
                  <li>Your deposited funds are not guaranteed</li>
                  <li>You could lose all deposited funds</li>
                </ul>
              </div>
              
              <div className="disclaimer-section">
                <h4>4. REGULATORY COMPLIANCE</h4>
                <ul>
                  <li>You are responsible for complying with local laws</li>
                  <li>Online gambling may be illegal in your jurisdiction</li>
                  <li>You must be of legal age to gamble in your jurisdiction</li>
                  <li>By proceeding, you confirm you are legally permitted to gamble</li>
                </ul>
              </div>
              
              <div className="disclaimer-section">
                <h4>5. NO WARRANTIES</h4>
                <ul>
                  <li>This dApp is provided "as is" without any warranties</li>
                  <li>No guarantee of fair operation or randomness</li>
                  <li>No guarantee of fund safety or recovery</li>
                  <li>You assume all risks associated with use</li>
                </ul>
              </div>
              
              <div className="disclaimer-notice">
                <p><strong>WARNING:</strong> This is a high-risk application. Do not use funds needed for essential expenses. Consider seeking help if you have gambling problems.</p>
              </div>
            </div>
            
            <div className="disclaimer-agreement">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  className="checkbox-input"
                />
                <span className="checkbox-custom"></span>
                <span className="checkbox-text">
                  I HAVE READ, UNDERSTOOD, AND AGREE TO ALL TERMS ABOVE. 
                  I ACKNOWLEDGE THE RISKS AND ASSUME FULL RESPONSIBILITY FOR ANY LOSSES.
                </span>
              </label>
            </div>
          </div>
          
          <div className="disclaimer-footer">
            <button
              className="disclaimer-btn"
              onClick={onAccept}
              disabled={!isChecked}
            >
              {isChecked ? "I ACCEPT - PROCEED TO DAPP" : "PLEASE READ AND ACCEPT TERMS"}
            </button>
            {!isChecked && (
              <p className="disclaimer-hint">
                You must read and accept the terms to continue
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };